import _includes from 'lodash/includes';
import { colorSortOptions } from '../../../utils/dropDownOptions';

const builderSearchAnalyticsEventHeader = (selectedColorSort, eventName, pageNumber) => {
  return ({
    category: {
      primaryCategory: 'browse'
    },
    eventInfo: {
      eventName,
    },
    displayAttributes: {
      productsAvailability: 'all products',
      sortBy: colorSortOptions.find((sort) => sort.value === selectedColorSort)?.label,
      viewType: 'grid',
      pageNumber,
    },
  });
};
export const buildSearchSortEvent = ({ selectedColorSort }) => {
  return builderSearchAnalyticsEventHeader(selectedColorSort, 'sort by', '1');
};
const buildFilterFooter = (analyticsEvent) => {
  const newAnalyticsEvent = { ...analyticsEvent };
  if (analyticsEvent.filter.length > 0) {
    newAnalyticsEvent.displayAttributes.pageNumber = '1';
  }
  return newAnalyticsEvent;
};
const matchColor = (colors, colorFilter, toMatch) => {
  let match = false;
  colors.forEach((color) => {
    if (colorFilter === color.tags.find((tag) => tag.includes(toMatch))?.split(';')[1]) {
      match = true;
    }
  });
  return match;
};
const buildFilter = (colors, selectedColorFilters, searchString, surfaces) => {
  const tags = colors.map((choice) => choice.tags
    .filter((tag) => tag.includes('filter:')));

  const colorFilterTags = [].concat(...tags)
    .map((tag) => tag.substring(tag.indexOf(';') + 1, tag.length));

  const colorFilters = [...new Set(colorFilterTags)];

  const allBrandOptions = colors.map((item) => {
    const currentSurface = surfaces?.find((surface) => Number(item.surfaceCode) === Number(surface.surfaceCode));
    return currentSurface?.desc;
  });

  const brands = [];
  allBrandOptions.forEach((filterTag) => brands.push(filterTag));

  const brandFilters = [...new Set(brands)];

  const filter = [];
  const toMatch = 'filter:color family;';
  selectedColorFilters.forEach((colorFilter) => {
    const colorOrBrand = matchColor(colors, colorFilter, toMatch);
    let position = 1;
    if (colorOrBrand) {
      position = `left rail:color family:${colorFilters.indexOf(colorFilter) + 1}`;
    } else {
      position = `left rail:brand:${brandFilters.indexOf(colorFilter) + 1}`;
    }
    filter.push({
      position,
      type: colorOrBrand ? 'color family' : 'brand',
      value: colorFilter,
      selectionMethod: 'default'
    });
  });
  if (searchString?.length > 0) {
    filter.push({
      position: 'searh box:color:0',
      type: 'color',
      value: searchString,
      selectionMethod: 'default'
    });
  }
  return filter;
};
// eslint-disable-next-line no-use-before-define
export const buildSearchColorChange = ({
  colors, selectedColorFilters, selectedColorSort, searchString, surfaces
}) => {
  let colorEvent = builderSearchAnalyticsEventHeader(selectedColorSort, 'filter by', '1');
  colorEvent.filter = buildFilter(colors, selectedColorFilters, searchString, surfaces);
  return buildFilterFooter(colorEvent);
};
// eslint-disable-next-line no-use-before-define
export const buildSearchTextChange = ({
  colors, selectedColorFilters, selectedColorSort, searchString, surfaces
}) => {
  let textEvent = builderSearchAnalyticsEventHeader(selectedColorSort, 'filter by', '1');
  textEvent.filter = buildFilter(colors, selectedColorFilters, searchString, surfaces);
  return buildFilterFooter(textEvent);
};
